export default __webpack_public_path__ + "static/media/836.145a2f7e.gif";